export const optionProcess = {
  user: 'smgweb',
  name: 'SMG Web Prestadores',
  description: 'CN=SMG Web Prestadores,OU=Seguros,OU=Total Users,DC=swm,DC=com,DC=ar',
  specificUser: 'smgwebprestadores',
};
